<ion-fab-button
  class="menu-element platform_Holder"
  [color]="themeColor"
  (click)="openMenu()"
>
  <ion-icon name="menu"></ion-icon>
</ion-fab-button>
